import { createFileRoute } from '@tanstack/react-router';

import { ProjectNumbersPage } from '@/areas/settings/manufacturing/Settings/ProjectNumbersPage/ProjectNumbersPage';
import { canViewOtherOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/settings/_menu/organization/automatic-rfq-number')({
    staticData: {
        access: { permissions: canViewOtherOrganizationSettings },
        chrome: 'none',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ProjectNumbersPage />;
}
